import * as React from 'react'
import { Input } from '@/components/ui/input'
import { FieldShell } from '@/pages/PublicJoinFormPage.fields'
import { personFieldTypes } from '@/pages/PublicJoinFormPage.helpers'
import type { OrganizationForm, PersonFieldName } from '@/pages/PublicJoinFormPage.types'

export function OrganizationFieldsSection({
  organization,
  errors,
  onChange,
}: {
  organization: OrganizationForm
  errors: Partial<Record<PersonFieldName, string>>
  onChange: (name: PersonFieldName, value: string) => void
}) {
  return (
    <section className="space-y-4" aria-labelledby="join-organization-heading">
      <h2 id="join-organization-heading" className="text-body font-semibold text-foreground">
        Organization Details
      </h2>
      {(['name', 'email', 'phone'] as PersonFieldName[]).map((field) => (
        <FieldShell
          key={field}
          id={`join-organization-${field}`}
          label={field === 'name' ? 'Organization name' : field[0].toUpperCase() + field.slice(1)}
          required={field === 'name'}
          error={errors[field]}
        >
          <Input
            id={`join-organization-${field}`}
            type={personFieldTypes[field]}
            value={organization[field]}
            aria-invalid={Boolean(errors[field])}
            onChange={(event) => onChange(field, event.target.value)}
          />
        </FieldShell>
      ))}
    </section>
  )
}
